function qualityTagMapping(qualityTag, qualityFeedback) {
  if (!qualityTag) return null
  const [tagValue, reasonValue] = splitTagValue(qualityTag)
  const mapping = {
    0: 'meetsQualityStandards',
    1: 'informationObscured',
    2: 'missingPages',
    3: 'wrongCaptureMode',
    4: 'motionBlurOrOutOfFocus',
    5: 'overUnderExposed',
    6: 'improperlyCropped',
    7: 'extraMaterialInFrame',
    8: 'wrongImageOrientation',
    9: 'skewed',
    10: 'reflections',
    11: 'duplicate',
    12: 'defective',
    13: 'other',
    14: 'multiple',
  }
  return {
    issue: mapping?.[tagValue] ?? 'other',
    reason: reasonValue,
    feedback: getFeedbackString(qualityFeedback),
  }
}

function splitTagValue(qualityTag) {
  const index = qualityTag.indexOf(':')
  if (index === -1) {
    return ['', qualityTag]
  }
  const tagValue = qualityTag.slice(0, index)
  const reasonValue = qualityTag.slice(index + 1)

  return [tagValue, reasonValue]
}

function getFeedbackString(qualityFeedback) {
  const feedbackPrefix = 'IMAGES:'
  const imageFeedback = qualityFeedback?.values?.find((value) => value.includes(feedbackPrefix)) || ''
  return imageFeedback.replace(feedbackPrefix, '')
}

export default function getImageQualityTags(artifact) {
  const qualityTag = artifact?.properties?.find((p) => p.name === 'auditResults')
  const qualityFeedback = artifact?.properties?.find((p) => p.name === 'auditFeedback')
  if (!qualityTag) return null
  return qualityTag.values.map((tag) => qualityTagMapping(tag, qualityFeedback))
}
